import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getCampaigncenterList } from 'components/campaigncenter/CampaigncenterAPI';
import { setCampaigncenterList, setCampaigncenterDashboardCampaigncenterList } from 'store/slice/ManufSlice';
import CampaigncenterDashboard from '../CampaigncenterDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function CampaigncenterPageImpl() {
    const dispatch = useDispatch();
    const { campaigncenterList} = useSelector((state)=>state.manufslice);
    
    const getCampaigncenterListSuccess = (list) =>{dispatch(setCampaigncenterList(list));}
    useEffect(() => {
        getCampaigncenterList(()=>{}, getCampaigncenterListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setCampaigncenterDashboardCampaigncenterList( campaigncenterList));
    },[ campaigncenterList])

    return (
        < CampaigncenterDashboard />
    )

}